import React, { useCallback, useContext } from 'react';
import { styled } from '@mui/material/styles';

import { IconButton } from '@mui/material';
import FiberManualRecord from '@mui/icons-material/FiberManualRecord';

import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';

import { GlobalContext } from "../GlobalContext";
styled(FiberManualRecord)({
    fontSize: "10px",
});
styled(
    IconButton,
    { shouldForwardProp: (propName) => !propName.startsWith('$') }
)(({ $active }) => ({
    cursor: "pointer",
    transition: "200ms",
    padding: 4,
    color: $active ? "#25adfb" : "#ccc",
    '&:hover': {
        color: $active ? "#909090" : "#fff",
    },
    '&:active': {
        color: $active ? "#909090" : "#fff",
    }
}));

export const CaptionDiv = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    zIndex: 65535,
    fontFamily: 'sans-serif',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1,
    color: '#ffffff',
    padding: '5px 5px',
    width: '100%',
    overflowWrap: 'break-word',
    background: 'rgb(0 0 0 / 25%)',
}));

const Carousel = ({ carouselProps, className, children, hasCaption }) => {

    const renderArrowPrev = useCallback((clickHandler, hasPrev, label) => {
        const onClick = (e) => {
            e.preventDefault(); e.stopPropagation();
            clickHandler();
        }
        return carouselProps.showArrows === true && (
            <button type="button" aria-label={label} className="control-arrow control-prev" onClick={onClick} />
        )
    });

    const renderArrowNext = useCallback((clickHandler, hasNext, label) => {
        const onClick = (e) => {
            e.preventDefault(); e.stopPropagation();
            clickHandler();
        }
        return carouselProps.showArrows === true && (
            <button type="button" aria-label={label} className="control-arrow control-next" onClick={onClick} />
        )
    });

    const renderIndicator = (
        onClickHandler, isSelected, index, label
    ) => {
        const onClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClickHandler();
        }
        return (
            <li
                className={"dot" + (isSelected ? " selected" : "")}
                onClick={onClick}
                onKeyDown={onClick}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                aria-label={`${label} ${index + 1}`}
            />
        );
    };

    return <ResponsiveCarousel {...carouselProps}
        className={className}
        showIndicators={children && children.length > 1}
        renderArrowNext={renderArrowNext}
        renderArrowPrev={renderArrowPrev}
        renderIndicator={renderIndicator}
    >
        {children}
    </ResponsiveCarousel>

}

export default Carousel;
